export const smoothiesData = {
    "smoothies": [
        {
            "id": 1,
            "name": "Fancy strawberry",
            "description": "Fruity acai bowl with a strawberry base, topped with fresh blueberries, shredded coconut and cacao nibs",
            "ingredients": ["strawberry", "blueberry", "coconut", "cocoa"],
            "nuts": false,
            "price": 9.25,
            "kcal": 253,
            "weight": 300,
            "time": 15,
            "url": "bowl-1.png"
        },
        {
            "id": 2,
            "name": "Anytime lime",
            "description": "Generous acai bowl with a kiwi base, topped with fresh kiwis, blueberries, bananas, pears, mint leaves, shredded coconut, chia seeds and granola",
            "ingredients": ["kiwi", "blueberry", "banana", "pear", "mint", "coconut", "granola"],
            "nuts": true,
            "price": 11.50,
            "kcal": 211,
            "weight": 350,
            "time": 5,
            "url": "bowl-2.png"
        },
        {
            "id": 3,
            "name": "Lola's granola",
            "description": "Simple acai bowl with a banana base, topped with frozen blueberries, granola and cacao nibs",
            "ingredients": ["banana", "blueberry", "granola", "cocoa"],
            "nuts": true,
            "price": 8.50,
            "kcal": 222,
            "weight": 250,
            "time": 10,
            "url": "bowl-3.png"
        },
        {
            "id": 4,
            "name": "Tropical crumble",
            "description": "Tropical acai bowl with a mixed berries base, topped with frozen raspberry, fresh pitaya (dragon fruit), coconut flakes and granola",
            "ingredients": ["berries", "raspberry", "pitaya", "granola"],
            "nuts": true,
            "price": 10.75,
            "kcal": 247,
            "weight": 275,
            "time": 15,
            "url": "bowl-4.png"
        },
        {
            "id": 5,
            "name": "Un poco coco'",
            "description": "Sweet acai bowl with a blueberry base, topped with fresh blueberries, shredded coconut and crushed biscuits",
            "ingredients": ["blueberry", "coconut", "biscuit"],
            "nuts": false,
            "price": 9.50,
            "kcal": 239,
            "weight": 300,
            "time": 5,
            "url": "bowl-5.png"
        },
        {
            "id": 6,
            "name": "Goji berry frenzy",
            "description": "Superfood packed acai bowl with a mango base, topped with fresh strawberries, goji berries and fenugreek seeds",
            "ingredients": ["mango", "strawberry", "goji"],
            "nuts": true,
            "price": 11.50,
            "kcal": 284,
            "weight": 325,
            "time": 10,
            "url": "bowl-6.png"
        },
        {
            "id": 7,
            "name": "Mama's banana",
            "description": "Strong acai bowl with a banana and coffee base, topped with fresh bananas, frozen raspberries, coconut flakes and granola",
            "ingredients": ["banana", "coffee", "raspberry", "coconut", "granola"],
            "nuts": true,
            "price": 8.50,
            "kcal": 229,
            "weight": 300,
            "time": 10,
            "url": "bowl-7.png"
        },
        {
            "id": 8,
            "name": "Chocolate fever",
            "description": "Rich acai bowl with a mixed berries base, topped with fresh strawberries, cacao nibs, granola and shredded coconut",
            "ingredients": ["berries", "strawberry", "cocoa", "granola", "coconut"],
            "nuts": true,
            "price": 12.25,
            "kcal": 277,
            "weight": 250,
            "time": 5,
            "url": "bowl-8.png"
        }
    ]
}